import React, { useCallback, useContext, useEffect, useState } from "react";
import FileList from "../../../FileList";
import FileUpload from "../../../FileUpload/index";
import { ToastContainer, toast } from "react-toastify";
import { TabTitle } from "../../../../util/titleChanger";
import { GlobalState } from "../../../../GlobalState";
import { useParams } from "react-router-dom";
import Loading from "../../../../util/Loading";
import { createNewStaff, createNewUser, updateStaff, updateUser } from "../../../../action";
import { api } from "../../../../util/urlConfig";

export default function StaffForm() {
  const { staffId } = useParams();
  TabTitle(staffId > 0 ? "Update Staff" : "Create Staff");
  const state = useContext(GlobalState);
  const signInUser = JSON.parse(localStorage.getItem("user_data"));

  const [staffDetail] = state.staffAPI.staffDetail;
  const [id, setId] = state.staffAPI.id;
  const [callback, setCallback] = state.staffAPI.callback;
  const [users] = state.userAPI.users;

  const [files, setFiles] = useState([]);
  const [btnName, setBtnName] = useState("Save");
  const [focused, setFocused] = useState(false);
  const [values, setValues] = useState({}); // Initialize as an empty object

  const uploadHandler = (file) => {
    if (files.length !== 0) {
      toast.warn("Already uploaded an image!");
    } else {
      if (file) {
        setFiles([...files, file]);
      }
    }
  };

  //Remove image files from file list component
  const removeHandler = (filename) => {
    setFiles(files.filter((file) => file.name !== filename));
  };

  //Focus input elements
  const handleFocus = (e) => {
    setFocused(true);
  };

  //Get value form input elements and assign into values states
  const onChangeValue = (e) => {
    e.preventDefault();
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  function dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  }

  const convertAsImage = (url) => {
    const toDataURL = (url) =>
      fetch(url)
        .then((response) => response.blob())
        .then(
          (blob) =>
            new Promise((resolve, reject) => {
              const reader = new FileReader();
              reader.onloadend = () => resolve(reader.result);
              reader.onerror = reject;
              reader.readAsDataURL(blob);
            })
        );

    toDataURL(url).then((dataUrl) => {
      try {
        const parts = url.split("/"); // safer for URLs
        const filename = parts[parts.length - 1];
        const [nameImage, ext] = filename.split(".");

        const fileData = dataURLtoFile(dataUrl, `${nameImage}.${ext}`);
        setFiles([fileData]);
      } catch (error) {
        console.error("Error converting image URL to File:", error);
      }
    });
  };

  useEffect(() => {
    if (staffId > 0) {
      setBtnName("Update");
      setId(staffId);
      var today = new Date();
      var dob = new Date(staffDetail.dob);

      setValues({
        first_name: staffDetail.first_name || "",
        last_name: staffDetail.last_name || "",
        contact_no: staffDetail.contact_no || "",
        dob: staffDetail.dob ? dob.toISOString().substring(0, 10) : today.toISOString().substring(0, 10),
        nic: staffDetail.nic || "",
        email: staffDetail.email || "",
        address1: staffDetail.address1 || "",
        address2: staffDetail.address2 || "",
        address3: staffDetail.address3 || "",
        village: staffDetail.village || "",
        city: staffDetail.city || "",
        country: staffDetail.country || "",
        bank_name: staffDetail.bank_details && staffDetail.bank_details.length > 0 ? staffDetail.bank_details[0].name : "",
        account_type: staffDetail.bank_details && staffDetail.bank_details.length > 0 ? staffDetail.bank_details[0].account_type : "",
        bank_no: staffDetail.bank_details && staffDetail.bank_details.length > 0 ? staffDetail.bank_details[0].bank_no : "",
      });

      const imgUrl = staffDetail.upload_image ? api + "/" + staffDetail.upload_image.image_url : {};
      if (Object.keys(imgUrl).length !== 0) {
        convertAsImage(imgUrl);
      }
    } else {
      // Reset values for a new staff creation
      setValues({});
    }
  }, [staffId, staffDetail, users, convertAsImage, setId]);

  const submitForm = (e) => {
    e.preventDefault();

    const form = new FormData();
    form.append("first_name", values.first_name);
    form.append("last_name", values.last_name);
    form.append("contact_no", values.contact_no);
    form.append("dob", values.dob);
    form.append("nic", values.nic);
    form.append("email", values.email);
    form.append("address1", values.address1);
    form.append("address2", values.address2);
    form.append("address3", values.address3);
    form.append("village", values.village);
    form.append("city", values.city);
    form.append("country", values.country);
    form.append("updatedBy", signInUser.id);
    form.append("uploaded_file", files[0]);

    const bank_data = {
      bank_name: values.bank_name || "",
      account_type: values.account_type || "",
      bank_no: values.bank_no || "",
    };

    form.append("bank", JSON.stringify(bank_data));

    //User Form Data
    var userFormData = new FormData();
    userFormData.append("first_name", values.first_name);
    userFormData.append("last_name", values.last_name);
    userFormData.append("nic", values.nic);
    userFormData.append("contact_no", values.contact_no);
    userFormData.append("email", values.email);
    userFormData.append("status", "Active");
    userFormData.append("password", values.password);
    userFormData.append("roleId", 2);
    userFormData.append("uploaded_file", files[0]);

    if (staffId > 0) {
      updateStaff(staffId, form, (res) => {
        const userData = users.data.filter((user) => {
          return user.nic === staffDetail.nic;
        });

        if (userData[0].id > 0) {
          const userId = userData[0].id;
          updateUser(userId, userFormData, (response) => {
            if (response.status === 200) {
              toast.success(res.data);
              setCallback(!callback);
            } else {
              toast.error(res.data);
              setCallback(!callback);
            }
          }).catch((err) => {
            console.log("Update user error : ", err);
          });
        } else {
          toast.error(res.data);
          setCallback(!callback);
        }
      });
    } else {
      form.append("createdBy", signInUser.id);
      createNewStaff(form, (res) => {
        userFormData.append("staff_id", res.staff.id);
        createNewUser(userFormData, (response) => {
          if (response.status === 200) {
            toast.success(res.data);
            setCallback(!callback);
          } else {
            toast.success(res.data);
            setCallback(!callback);
          }
        }).catch((err) => {
          console.log("Create user error : ", err);
        });
      });
    }
  };

  return !staffDetail ? (
    <div className="form-container">
      <div className="loading-page-container">
        <Loading />
      </div>
    </div>
  ) : (
    <div className="form-container">
      <header>Staff Form</header>
      <form onSubmit={submitForm} className="form">
        <FileUpload uploadHandler={uploadHandler} />
        <FileList files={files} removeHandler={removeHandler} />

        {/* Add your form fields here... */}
        {/* For example: */}
        <div className="input-box">
          <label htmlFor="first_name">First Name</label>
          <input
            type="text"
            name="first_name"
            id="first_name"
            placeholder="Enter First Name"
            value={values.first_name || ""}
            required
            pattern="^[A-Za-z0-9 ,]{3,}$"
            onBlur={handleFocus}
            focused={focused.toString()}
            onChange={onChangeValue}
          />
        </div>

        {/* Other form fields... */}

        <div className="form-button">
          <button className="add_new">{btnName}</button>
        </div>
      </form>
      <ToastContainer />
    </div>
  );
}
